import React from 'react';
import { formatTime } from '../utils/formatTime';

interface MobileTimerProps {
  modelName: string;
  modelTimeRemaining: number;
  playerTimeRemaining: number;
  activePlayer: 'player' | 'model';
  onResign: () => void;
}

const MobileTimer: React.FC<MobileTimerProps> = ({
  modelName,
  modelTimeRemaining,
  playerTimeRemaining,
  activePlayer,
  onResign
}) => {
  return (
    <div className="w-full flex justify-between items-center bg-black/90 border border-terminal-green p-2 rounded">
      <div className={`flex-1 flex flex-col items-center ${activePlayer === 'model' ? 'text-terminal-green' : 'text-terminal-green/70'}`}>
        <span className="font-vt323 text-2xl">{formatTime(modelTimeRemaining)}</span>
        <span className="text-xs truncate">{modelName}</span>
      </div>
      
      <button
        onClick={onResign}
        className="mx-5 bg-transparent border border-terminal-green/50 text-terminal-green/80 px-2 py-1 text-xs hover:bg-dark-green/20 rounded"
        style={{ minWidth: '60px' }}
      >
        RESIGN
      </button>
      
      <div className={`flex-1 flex flex-col items-center ${activePlayer === 'player' ? 'text-terminal-green' : 'text-terminal-green/70'}`}>
        <span className="font-vt323 text-2xl">{formatTime(playerTimeRemaining)}</span>
        <span className="text-xs">You</span>
      </div>
    </div>
  );
};

export default MobileTimer;